import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Calcbov.css";
import logo from "../../assets/calcbov.png"; 
import img1 from "../../assets/bov1.png"; // Imagem 1 - gado
import img2 from "../../assets/bov2.jpg"; // Imagem 2 - pastagem
import img3 from "../../assets/bov3.png"; // Imagem 3 - produtividade
import img4 from "../../assets/bov4.jpg"; // Imagem 4 - gestão
import img5 from "../../assets/bov5.jpg"; // Imagem 5 - análise

const CalcBov = () => {
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    adaptiveHeight: true
  };

  const advantages = [
    {
      title: "Produção e Produtividade",
      content: "A produtividade refere-se à quantidade de bezerros desmamados e vendidos pelas vacas do plantel, no caso da cria, dos bois magros produzidos, no caso da recria, e dos bois terminados no confinamento. Também abrange a taxa de lotação, o ganho de peso entre a fase inicial e final de cada categoria (cria, recria e engorda), a taxa de mortalidade, as arrobas produzidas, etc.",
      image: img3
    },
    {
      title: "Custo do Capital e Depreciação",
      content: "Esse indicador avalia o retorno financeiro do capital aplicado em benfeitorias, máquinas, equipamentos e terra, caso estivesse investido no mercado financeiro. A depreciação, por sua vez, reflete a perda de valor do capital devido ao uso intenso ao longo do tempo.",
      image: img4
    },
    {
      title: "Custos Operacionais",
      content: "Os custos operacionais englobam todas as despesas recorrentes necessárias para manter a produção de bovinos de corte, como mão de obra, manutenção de equipamentos, insumos como fertilizantes, vacinas e medicamentos, inseminação artificial e despesas financeiras.",
      image: img5
    },
    {
      title: "Receita e Rentabilidade",
      content: "Refere-se ao total de dinheiro gerado pela venda dos animais, incluindo a venda de animais de descarte e reposição. A receita é um indicador vital da saúde financeira do negócio, pois deve ser suficiente para cobrir os custos operacionais e totais, além de gerar lucro.",
      image: img1
    },
    {
      title: "Relatório Final",
      content: "O relatório final oferece uma visão integrada dos resultados calculados e simulados do negócio, facilitando a tomada de decisões estratégicas. Essa ferramenta é essencial para monitorar o desempenho contínuo, identificar áreas de melhoria e aumentar a eficiência na gestão.",
      image: img2
    }
  ];

  const plans = [
    {
      name: "Mensal",
      price: "R$19,90/mês",
      features: [
        "Cálculos ilimitados",
        "Simulações ilimitadas",
        "Suporte disponível",
        "Pagamento mensal"
      ]
    },
    {
      name: "Trimestral",
      price: "R$49,90/trimestre",
      features: [
        "Cálculos ilimitados",
        "Simulações ilimitadas",
        "Suporte disponível",
        "Pagamento a cada três meses"
      ]
    },
    {
      name: "Anual",
      price: "R$199,90/ano",
      features: [
        "Cálculos ilimitados",
        "Simulações ilimitadas",
        "Suporte disponível",
        "Pagamento anual"
      ]
    }
  ];

  return (
    <div className="calcbov-page-container">
      <header className="calcbov-page-header">
        <div className="calcbov-logo-container">
          <img src={logo} alt="CalcBov Logo" className="calcbov-page-logo" />
        </div>
        <h1 className="calcbov-title">CalcBov</h1>
        <p className="calcbov-header-subtitle">
          Com o CalcBov você obterá independência e autonomia quando se trata das economias e finanças do seu negócio, de maneira rápida, simples, segura e eficaz.
        </p>
      </header>

      <section className="calcbov-hero-section">
        <Slider {...sliderSettings} className="calcbov-image-slider">
          <div className="calcbov-slide">
            <img src={img1} alt="Controle de Custos" />
            <div className="calcbov-slide-caption">
              <h3>Controle de Custos</h3>
              <p>Monitoramento detalhado de despesas para otimizar recursos e maximizar lucros</p>
            </div>
          </div>
          <div className="calcbov-slide">
            <img src={img2} alt="Análise de Desempenho" />
            <div className="calcbov-slide-caption">
              <h3>Análise de Desempenho</h3>
              <p>Visão abrangente sobre o estado financeiro do seu negócio</p>
            </div>
          </div>
        </Slider>
      </section>

      <section className="calcbov-features-section">
        <div className="calcbov-feature-card">
          <div className="calcbov-feature-content">
            <h3>Sobre o App</h3>
            <p>
              O sistema permite o controle detalhado de custos, monitorando despesas com alimentação, cuidados com o gado e operações gerais. Facilita o planejamento financeiro ao auxiliar na criação de orçamentos e planos, otimizando recursos e maximizando os lucros.
            </p>
          </div>
        </div>
        <div className="calcbov-feature-card">
          <div className="calcbov-feature-content">
            <h3>E mais...</h3>
            <p>
              A análise de desempenho proporciona uma visão abrangente sobre o estado financeiro do negócio, identificando áreas de lucro e oportunidades de melhoria. Com foco em transparência, o sistema possibilita que todos os envolvidos acessem informações financeiras atualizadas, fortalecendo a confiança e promovendo uma colaboração eficaz no ambiente de trabalho.
            </p>
          </div>
        </div>
      </section>

      <section className="calcbov-plans-section">
        <h2 className="calcbov-section-title">Confira nossos planos</h2>
        <div className="calcbov-plans-grid">
          {plans.map((plan, index) => (
            <div className="calcbov-plan-card" key={index}>
              <div className="calcbov-plan-header">
                <h3>{plan.name}</h3>
                <p className="calcbov-plan-price">{plan.price}</p>
              </div>
              <ul className="calcbov-plan-features">
                {plan.features.map((feature, i) => (
                  <li key={i}>{feature}</li>
                ))}
              </ul>
              <Link to="/login" className="calcbov-plan-button">Assinar</Link>
            </div>
          ))}
        </div>
      </section>

      <section className="calcbov-advantages-section">
        <h2 className="calcbov-section-title">Vantagens de obter o CalcBov</h2>
        <div className="calcbov-advantages-grid">
          {advantages.map((advantage, index) => (
            <div className="calcbov-advantage-card" key={index}>
              <div className="calcbov-advantage-image">
                <img src={advantage.image} alt={advantage.title} />
              </div>
              <div className="calcbov-advantage-content">
                <h3>{advantage.title}</h3>
                <p>{advantage.content}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <div className="calcbov-cta-container">
        <Link to="/login" className="calcbov-cta-button">Comece agora</Link>
        <Link to="/" className="calcbov-back-link">Voltar para Home</Link>
      </div>
    </div>
  );
};

export default CalcBov;